import { render, staticRenderFns } from "./import_pdfs_precheck.vue?vue&type=template&id=f38f4da8&scoped=true&"
import script from "./import_pdfs_precheck.vue?vue&type=script&lang=js&"
export * from "./import_pdfs_precheck.vue?vue&type=script&lang=js&"
import style0 from "./import_pdfs_precheck.vue?vue&type=style&index=0&id=f38f4da8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f38f4da8",
  null
  
)

export default component.exports